import { Box } from "@mui/material";
import { ReactWidgetWithStyles } from "../../../../../../interfaces/Interfaces";
import React from "react";
import withStandardProps from "./HOCs/withStandardStyles";
import { addConfigToStyle } from "../../../../../../helpers/Helpers";
import { generateMarginString } from "./options/MarginSelector";

const ImageField = ({ widget, standardStyles }: ReactWidgetWithStyles) => {
  const config = widget.config || {};
  const styles: any = {
    maxWidth: "100%",
    Height: "auto",
  };
  const parentStyles: any = {};

  addConfigToStyle("width", config, styles);

  addConfigToStyle("textAlign", config, parentStyles);

  if (config["borderRadius"]) {
    styles.borderRadius = generateMarginString(config["borderRadius"]);
  }

  if (widget.config.src) {
    return (
      <Box sx={{ ...parentStyles, width: "100%" }}>
        <Box
          component="img"
          sx={{ ...styles, ...standardStyles }}
          src={widget.config.src}
        ></Box>
      </Box>
    );
  } else {
    return <Box sx={styles}>{widget.type}</Box>;
  }
};

export default withStandardProps(ImageField);
